import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ApiCemeteryConstants } from "../../constants/api-constants/api-cemetery.constants";
let CemeteryService = class CemeteryService {
    http;
    constructor(http) {
        this.http = http;
    }
    getFamiliesObservable(jobId) {
        return this.http.get(`${ApiCemeteryConstants.URL}/${jobId}/${ApiCemeteryConstants.FUNCTION_GET_FAMILY}`)
            .pipe(map((response) => {
            return response;
        }));
    }
    getFamilySaveObservable(jobId, params) {
        return this.http.post(`${ApiCemeteryConstants.URL}/${jobId}/${ApiCemeteryConstants.FUNCTION_SET_FAMILY}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    getApplicationSaveDetailsObservable(appId, params) {
        return this.http.post(`${ApiCemeteryConstants.URL}/${appId}/${ApiCemeteryConstants.FUNCTION_SET_DETAILS}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    getApplicationSaveDeceasedObservable(appId, params) {
        return this.http.post(`${ApiCemeteryConstants.URL}/${appId}/${ApiCemeteryConstants.FUNCTION_SET_DECEASED}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
CemeteryService = __decorate([
    Injectable({
        providedIn: "root"
    })
], CemeteryService);
export { CemeteryService };
